import createAction from '../../common/services/create-action';

export const CALCULATE_SUBCATEGORIES_PERMISSIONS = 'CALCULATE_SUBCATEGORIES_PERMISSIONS';
export const calculateSubcategoriesPermissions = createAction(
  CALCULATE_SUBCATEGORIES_PERMISSIONS,
  () => undefined,
  payload => payload,
);
